import { render, staticRenderFns } from "./com-service.vue?vue&type=template&id=40f9ed24&scoped=true&"
import script from "./com-service.vue?vue&type=script&lang=js&"
export * from "./com-service.vue?vue&type=script&lang=js&"
import style0 from "./com-service.vue?vue&type=style&index=0&id=40f9ed24&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f9ed24",
  null
  
)

export default component.exports